import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LibNumberInputComponent } from './number-input.component';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    LibNumberInputComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinner,
    MatButtonModule,
    MatInputModule,
    MatIconModule
  ],
  exports: [
    LibNumberInputComponent
  ]
})
export class LibNumberInputModule { }
